// @ts-nocheck
import React, { useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare, MessageSquarePlus } from "lucide-react";
import { addSheetNote, getViewer } from "@/lib/liveSheets";

interface Props {
  registrationId: string;
  eventId: string;
  tokenId: string;
  notes: any[];
  permission: "view" | "comment" | "edit";
  onAdded: () => void;
}

export default function NotesCell({ registrationId, eventId, tokenId, notes = [], permission, onAdded }: Props) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const canWrite = permission === "comment" || permission === "edit";

  const submit = async () => {
    const { name, email } = getViewer();
    if (!text.trim()) return;
    setSaving(true);
    try {
      await addSheetNote({
        registrationId,
        eventId,
        tokenId,
        authorName: name || email || "Guest",
        note: text.trim(),
      });
      setText("");
      onAdded();
      toast.success("Note added");
    } catch (e: any) {
      toast.error(e.message || "Failed to add note");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative inline-flex items-center text-slate-500 hover:text-[#002E62]">
          {notes.length ? <MessageSquare className="h-4 w-4" /> : <MessageSquarePlus className="h-4 w-4" />}
          {notes.length > 0 && (
            <span className="ml-1 text-xs font-medium">{notes.length}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-3">
          <h4 className="text-sm font-semibold">Notes</h4>
          <div className="max-h-48 space-y-2 overflow-y-auto">
            {notes.length === 0 && (
              <p className="text-xs text-muted-foreground">No notes yet.</p>
            )}
            {notes.map((n) => (
              <div key={n.id} className="rounded bg-slate-50 p-2">
                <p className="text-sm">{n.note}</p>
                <p className="mt-1 text-[10px] text-muted-foreground">
                  {n.author_name} · {n.created_at ? format(new Date(n.created_at), "MMM d, h:mm a") : ""}
                </p>
              </div>
            ))}
          </div>
          {canWrite && (
            <div className="space-y-2">
              <Textarea
                rows={2}
                placeholder="Add a note…"
                value={text}
                onChange={(e) => setText(e.target.value)}
              />
              <Button size="sm" className="w-full bg-[#002E62] hover:bg-[#002E62]/90" disabled={saving} onClick={submit}>
                Add note
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
